module.exports = __webpack_public_path__ + "img/main.558bbd8b.jpg";